<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    	<div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <gofix-card class="mb-0 heig-frame-child" fullContent>
                <gofix-default-table
                    :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    @delete-items="deleteItems"
                    @import-items="importItems"
                    ref="gofixTable">
                    <template slot="gofix_table:before-control-right" slot-scope="row">
                        <template v-if="$checkSupplier()">
                            <gofix-button label="Import SFTP" class="mr-4" @click="modalSubmitSFTP()"></gofix-button>
                            <gofix-button label="Submit Document" class="mr-4" @click="modalSubmitDocument()"></gofix-button>
                        </template>
                    </template>
                    <template slot="gofix_table:batch_no" slot-scope="row">
                        <span class="checklistLink" @click="goToDetail(row.item.id)"> {{ row.item.batch_no }} </span>
                    </template>
                    <template slot="gofix_table:batch_date" slot-scope="row">
                        {{ row.item.batch_date ? row.item.batch_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                    </template>
                    <template slot="gofix_table:created_at" slot-scope="row">
                        {{ row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}
                    </template>
                    <template slot="gofix_table:status" slot-scope="row">
                        <span v-if="row.item.status == 'Validation Error'" class="checklistLink" @click="goToError(row.item.id)"> {{ row.item.status }} </span>
                    </template>
                    <template slot="gofix_table:reviewed_by" slot-scope="row">
                        {{ row.item.reviewed_by ? row.item.reviewed_by.name : '' }}
                    </template>
                    <template slot="gofix_table:submitted_by" slot-scope="row">
                        {{ row.item.submitted_by ? row.item.submitted_by.name : '' }}
                    </template>
                    <template slot="gofix_table:batch_error_count" slot-scope="row">
                        <span v-if="row.item.batch_error_count" class="checklistLink" @click="goToError(row.item.id)"> {{ row.item.batch_error_count ? row.item.batch_error_count : 0}} </span>
                    </template>
                    <template slot="gofix_table:attachments" slot-scope="row">
                        <div v-if="row.item.attachments !== null && row.item.attachments.length > 0">
                            <span class="d-block" v-for="item in row.item.attachments">
                                <a :href="item.url.original" v-text="item.image_file_name" @click.prevent="downloadItem(item.url.original, item.image_file_name)"></a>
                            </span>
                        </div>
                        <div v-else> </div>
                    </template>
                    <template slot="gofix_table:gst" slot-scope="row">
                        {{ `${$accounting.formatMoney(row.item.gst)}` }}
                    </template>
                    <template slot="gofix_table:total_price" slot-scope="row">
                        {{ `${$accounting.formatMoney(row.item.total_price)}` }}
                    </template>
                </gofix-default-table>
            </gofix-card>
        </div>
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-Import"
            :title="modal.title"  
            hide-footer 
            v-model="modal.status">
            <b-row>
                <b-col md="12">
                    <gofix-form-dropdown
                        :multiple="false"
                        label="File Type"
                        vLabel="name"
                        :clearable="false"
                        :options="['DORJ', 'INVOICE', 'DORJ Attachments', 'INVOICE Attachments', 'WO Attachments', 'WO Attachments (Read Content File)']"
                        v-model="modal.fileType"
                        :disabled="modal.fileTypeDisable === true"
                        required />
                </b-col>
            </b-row>
            <b-row v-if="['DORJ Attachments', 'INVOICE Attachments', 'WO Attachments', 'WO Attachments (Read Content File)'].includes(modal.fileType)">
                <b-col md="12" class="mb-4">
                    <div class="d-flex flex-wrap">
                        <template v-for="(attachment,index) in modal.attachments">
                            <gofix-button class="icon-svg icon-svg-right mr-2 mb-2" :label="attachment.name" outline dark :key="index">
                                <template slot="gofix:button:afterLabel">
                                    <span class="icon ml-2" @click="removeImage(index)">
                                        <svg width="12" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.3 0.99404C13.1131 0.797476 12.8595 0.687011 12.595 0.687011C12.3305 0.687011 12.0768 0.797476 11.89 0.99404L6.99997 6.11669L2.10997 0.983543C1.92314 0.786979 1.66949 0.676514 1.40497 0.676514C1.14045 0.676514 0.886802 0.786979 0.699971 0.983543C0.309971 1.39293 0.309971 2.05426 0.699971 2.46365L5.58997 7.5968L0.699971 12.73C0.309971 13.1393 0.309971 13.8007 0.699971 14.2101C1.08997 14.6195 1.71997 14.6195 2.10997 14.2101L6.99997 9.07691L11.89 14.2101C12.28 14.6195 12.91 14.6195 13.3 14.2101C13.69 13.8007 13.69 13.1393 13.3 12.73L8.40997 7.5968L13.3 2.46365C13.68 2.06476 13.68 1.39294 13.3 0.99404Z" fill="black" fill-opacity="0.6" />
                                        </svg>
                                    </span>
                                </template>
                            </gofix-button>  
                        </template>
                        <gofix-button class="icon-svg icon-svg-left mb-2" label="Add file" outline @click="modal.attachment.open = true">
                            <template slot="gofix:button:beforeLabel">
                                <span class="icon mr-2">
                                    <svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.6537 8.20604C11.6355 8.1827 11.6121 8.16382 11.5855 8.15083C11.5588 8.13785 11.5296 8.1311 11.4999 8.1311C11.4703 8.1311 11.441 8.13785 11.4144 8.15083C11.3877 8.16382 11.3644 8.1827 11.3461 8.20604L8.61175 11.6655C8.58921 11.6943 8.57522 11.7288 8.57139 11.7652C8.56755 11.8016 8.57403 11.8383 8.59007 11.8711C8.60612 11.904 8.63108 11.9317 8.66212 11.951C8.69315 11.9703 8.72899 11.9805 8.76556 11.9805H10.5698V17.8984C10.5698 18.0058 10.6576 18.0937 10.7651 18.0937H12.2299C12.3373 18.0937 12.4252 18.0058 12.4252 17.8984V11.9829H14.2343C14.3979 11.9829 14.4882 11.7949 14.3881 11.668L11.6537 8.20604Z" fill="#F05600" />
                                        <path d="M18.8096 5.95264C17.6914 3.00342 14.8423 0.90625 11.5049 0.90625C8.16748 0.90625 5.31836 3.00098 4.2002 5.9502C2.10791 6.49951 0.5625 8.40625 0.5625 10.6719C0.5625 13.3696 2.74756 15.5547 5.44287 15.5547H6.42188C6.5293 15.5547 6.61719 15.4668 6.61719 15.3594V13.8945C6.61719 13.7871 6.5293 13.6992 6.42188 13.6992H5.44287C4.62012 13.6992 3.84619 13.3721 3.27002 12.7788C2.69629 12.188 2.39111 11.3921 2.41797 10.5669C2.43994 9.92236 2.65967 9.31689 3.05762 8.80664C3.46533 8.28662 4.03662 7.9082 4.67139 7.73975L5.59668 7.49805L5.93604 6.60449C6.146 6.04785 6.43896 5.52783 6.80762 5.05664C7.17156 4.58962 7.60267 4.17908 8.08691 3.83838C9.09033 3.13281 10.272 2.75928 11.5049 2.75928C12.7378 2.75928 13.9194 3.13281 14.9229 3.83838C15.4087 4.18018 15.8384 4.59033 16.2021 5.05664C16.5708 5.52783 16.8638 6.05029 17.0737 6.60449L17.4106 7.49561L18.3335 7.73975C19.6567 8.09619 20.582 9.2998 20.582 10.6719C20.582 11.48 20.2671 12.2417 19.6958 12.813C19.4156 13.0948 19.0823 13.3182 18.7152 13.4703C18.3481 13.6225 17.9545 13.7003 17.5571 13.6992H16.5781C16.4707 13.6992 16.3828 13.7871 16.3828 13.8945V15.3594C16.3828 15.4668 16.4707 15.5547 16.5781 15.5547H17.5571C20.2524 15.5547 22.4375 13.3696 22.4375 10.6719C22.4375 8.40869 20.897 6.5044 18.8096 5.95264Z" fill="#F05600" />
                                    </svg>
                                </span>
                            </template>
                        </gofix-button>
                    </div>
                </b-col>
                <b-modal :no-close-on-backdrop="true" title="Import File" ref="modal-Import-attachments" id="modal-Contract-Attachments" modal-class="gofixUploadFileModal" hide-footer v-model="modal.attachment.open">
                    <b-form class="formV2">
                        <b-form-group :label="modal.attachment.filename" >
                            <b-form-file ref="file-input" accept=".pdf" v-model="modal.attachment.fileAttachment" ></b-form-file>
                        </b-form-group>
                        <b-button-group class="text-right d-block">
                            <gofix-button label="SUBMIT" @click="addAttachment" noBorder :loading="modal.attachment.loading"></gofix-button>
                        </b-button-group>
                    </b-form>
                </b-modal>
            </b-row>
            <b-form-group v-else>
                <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="modal.check" ref="file-input-bdj" accept=".csv" v-model="modal.file" >
                    <template slot="file-name" slot-scope="{ names }">
                    <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                </b-form-file>
            </b-form-group>
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="submitDocument" noBorder :disabled="modal.loading == true"></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-Import"
            :title="modal.sftp.title"  
            hide-footer 
            v-model="modal.sftp.open">
            <b-row>
                <b-col md="12">
                    <gofix-form-dropdown
                        :multiple="false"
                        label="File Type"
                        vLabel="name"
                        :clearable="false"
                        :options="['DORJ', 'INVOICE']"
                        v-model="modal.sftp.data.file_type"
                        required />
                </b-col>
            </b-row>
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="submitDocumentSFTP" noBorder :disabled="modal.sftp.loading == true"></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    export default {
        name: 'batch-submission-summary',
        components: { },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['batch_submission_summary']));
            return {
                tableConfig:{
                    name: 'lmu-batch-submission-listing',
                    controls:{
                        create: false,
                        update: true,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    sortColumn: "id",
                    sortDirection: "desc",
                },
                tableItems: [],
                modal: {
                    status: false,
                    title: 'Submit Document',
                    loading: false,
                    fileType: 'DORJ',
                    fileTypeDisable: false,
                    check: '',
                    file: null,
                    fileName: "Click Browse to upload file",
                    LMUInboundLogID: '',
                    attachments: [],
                    attachmentUpdate: [],
                    attachmentDeleteId: [],
                    submission_mode:'Portal',
                    attachment_tmp: {
                        delete: [],
                        add: [],
                        update: []
                    },
                    attachment: {
                        open: false,
                        loading: false,
                        filename: "Click Browse to upload file",
                        fileAttachment: null,
                        image_file_title: '',
                        id: 0,
                        index: '',
                        edit: 0
                    },
                    download: {
                        open: false,
                        loading: false,
                        title: '',
                        attachments: []
                    },
                    sftp: {
                        open: false,
                        loading: false,
                        title: 'Import Document from SFTP',
                        data: {
                            submission_mode:'SFTP',
                            fitle_type:'DORJ'
                        }
                    }
                }
            }
        },
        created() {
            
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                contractDropdown: 'ContractController/contractDropdown',
            }),
        },
        watch: {
            "modal.attachment.fileAttachment": function(val) {
                this.modal.attachment.filename = 'Click Browse to upload file';
                if (val) {
                    let extensionAccept = ['pdf'];
                    let extensionArray = val.name.split('.');
                    let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                    if (!extensionAccept.includes(extension)) {
                        this.$refs['file-input'].reset()
                        return this.$bvToast.toast('File format is incorrect. Please select a .pdf file!', {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'warning',
                            solid: true
                        })
                    }
                    this.modal.attachment.filename = val.name
                }
            },
            "modal.fileType": function(val) {
                if(val) {
                    this.modal.attachment.fileAttachment = null
                    this.modal.attachments = []
                    this.modal.file = null
                }
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve, reject } = await callback();
                
                await this.$store.dispatch("BatchSubmissionController/getBatchSubmission", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => { 
                    reject()
                })
            },
            async deleteItems(callback){
                
            },
            async importItems(callback){
                
            },
            changeFile(){
                this.modal.check = this.modal.file ? false : true;
            },
            downloadItem(url, label) {
                axios.get(url, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = label
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch()
            },
            goToDetail(item) {
                if (item) {
                    if(this.$checkSupplier()) {
						return this.$router.push(`/supplier-portal/batch-submission-summary/${item}`)
					}
					return this.$router.push(`/v2/batch-submission-summary/${item}`)
                }
            },
            goToError(item) {
                if (item) {
                    if (item) {
                        if(this.$checkSupplier()) {
                            return this.$router.push(`/supplier-portal/batch-submission-summary/${item}/logs`)
                        }
                        return this.$router.push(`/v2/batch-submission-summary/${item}/logs`)
                    }
                }
            },
            modalSubmitDocument() {

                /* if(!this.ClientContractID || !this.ClientContractID.id) {
                    return this.$alertNotification("Please choose a contract.", "danger");
                } */
                this.modal.fileType = 'DORJ'
                this.modal.attachment.fileAttachment = null
                this.modal.attachments = []
                this.modal.file = null
                this.modal.fileTypeDisable = false
                this.modal.status = true
            },
            async submitDocument() {
               
                this.modal.loading = true
                let current_contract_id = 0;
                
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    /* this.modal.loading = false
                    return this.$alertNotification("Please choose a contract.", "danger"); */
                    /* current_contract_id = this.contractDropdown.data[0].id */
                } else {
                    /* current_contract_id = this.ClientContractID.id */
                }

                if(!this.modal.fileType) {
                    this.modal.loading = false
                    return this.$alertNotification("Please choose a file type.", "danger");
                }
                
                let file_import_data = '';

                if ( !['DORJ Attachments', 'INVOICE Attachments', 'WO Attachments', 'WO Attachments (Read Content File)'].includes(this.modal.fileType) ) {

                    if(!this.modal.file) {
                        this.modal.loading = false
                        return this.$alertNotification("Please choose a file import.", "danger");
                    }

                    file_import_data = this.modal.file;
                } else {

                    if ( this.modal.attachments.length == 0 ) {
                        this.modal.loading = false
                        return this.$alertNotification("Please choose a file import.", "danger");
                    }
                    
                    file_import_data = this.modal.attachments;
                }

                await this.$store.dispatch(`BatchSubmissionController/importItems`, {
                    /* contract_id: this.ClientContractID.id, */
                    submission_mode : this.modal.submission_mode,
                    file_import: file_import_data,
                    file_type: this.modal.fileType,
                    /* lmu_inbound_log_id: this.modal.LMUInboundLogID */
                })
                .then(response => {
                    if(response.data.data.data && response.data.data.data.count && response.data.data.data.count.failed) {
                        this.$alertNotification("Some rows cannot be imported. Please go to Import Logs for more details.", "danger");
                    } else {
                        this.$alertNotification("Successfully imported", "success");
                    }
                    this.$refs.gofixTable.reloadTableItems();
                    this.modal.loading = false
                    this.modal.status = false
                    this.modal.fileTypeDisable = false
                    this.modal.LMUInboundLogID = ''
                    this.modal.file = ''
                    this.modal.attachments = []
                    this.modal.fileType = 'DORJ'
                })
                .catch(error => {
                    this.modal.loading = false
                    this.modal.status = false
                    this.modal.fileTypeDisable = false
                    this.modal.LMUInboundLogID = ''
                    this.modal.file = ''
                    if(error.response.data.error && error.response.data.error.message) {
                        if(error.response.data.error.message.hasOwnProperty('data')) {
                            if(error.response.data.error.message.data) {
                                if(error.response.data.error.message.data.count) {
                                    if(error.response.data.error.message.data.count.failed) {
                                        this.$alertNotification("Some rows cannot be imported. Please go to Import Logs for more details.", "danger")
                                    }
                                    return
                                }
                                return this.showToast(error.response.data.error.message.data)
                            }
                            return this.$alertNotification(error.response.data.error.message.message, "danger")
                        }
                    }
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(error.response.data.error.message, "danger")
                });
            },
            openModal(item) {
                if ( item ) {
                    this.modal.status = true
                    this.modal.loading = false
                    this.modal.fileType = item.file_type
                    this.modal.fileTypeDisable = true
                    this.modal.LMUInboundLogID = item.id
                }
            },
            /*-- Attachment --------*/
            addAttachment() {
                if(!this.modal.attachment.fileAttachment) {
                    return this.$bvToast.toast('Please select the file.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                this.modal.attachments.push(this.modal.attachment.fileAttachment);
                this.modal.attachment.fileAttachment = null;
                this.modal.attachment.open = false;
            },
            removeImage(index) {
                this.modal.attachments.splice(index, 1);
            },
            modalSubmitSFTP(){
                this.modal.sftp.data = {
                    submission_mode: 'SFTP',
                    file_type:'DORJ'
                };
                this.modal.sftp.open = true;
            },
            async submitDocumentSFTP(){
                this.modal.sftp.loading = true;
                await this.$store.dispatch(`BatchSubmissionController/importItemsSFTP`, this.modal.sftp.data)
                .then(response => {
                    this.$alertNotification("Submiited. Please check log for detail!", "success");
                    this.$refs.gofixTable.reloadTableItems();
                    this.modal.sftp.open = false
                    this.modal.sftp.loading = false
                })
                .catch(error => {
                    this.modal.sftp.loading = false
                    this.modal.sftp.open = false
                    this.$refs.gofixTable.reloadTableItems();
                    if (error.response.data.error && error.response.data.error.message) {
                        this.$alertNotification(error.response.data.error.message, "danger")
                    }
                });
            },
            showToast(data) {
                // Use a shorter name for this.$createElement
                const h = this.$createElement
                let elements = []
                for(let i = 0; i < data.length; i++) {
                    elements.push(h('li', data[i]))
                }
                
                // Create the message
                const vNodesMsg = h(
                    'div',
                    [
                        h(
                            'p', 
                            { class: ['mb-0'] },
                            [ 'Please check the list of errors below:' ]
                        ),
                        h(
                            'ul',
                            { class: ['mb-0', 'pl-25'] },
                            elements
                        ),
                        
                    ]
                )
                // Pass the VNodes as an array for message and title
                this.$bvToast.toast([vNodesMsg], {
                    title: "Notification",
                    solid: true,
                    variant: 'danger',
                    autoHideDelay: 3000,
                })
            }
        }
    }
</script>